"use client";
import React, { useEffect, useState } from "react";
import { Table, TableBody, TableCell, TableHeader, TableRow } from "../../../components/ui/table";
import Checkbox from "../../../components/form/input/Checkbox";

const apiUrl = process.env.REACT_APP_API_URL;

export default function Venue() {
  const token = localStorage.getItem("token");
  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [venues, setVenues] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const fetchVenues = async () => {
    const response = await fetch(`${apiUrl}/venues`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        token: token || "",
      },
    });
    const result = await response.json();

    if (result.success) {
      setVenues(result.venues);
    } else {
      setVenues([]);
    }

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
  };

  useEffect(() => {
    fetchVenues();
  }, []);

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]); // Unselect all
    } else {
      const allVenueNames = venues.map((v) => v.name); 
      setSelectedRows(allVenueNames);
    }
    setSelectAll(!selectAll);
  };

  useEffect(() => {
    // "Available in all venues" checkbox
    if (venues.length > 0 && selectedRows.length === venues.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  }, [selectedRows, venues]);

  const handleRowSelect = (venueName: string) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(venueName)
        ? prevSelected.filter((name) => name !== venueName)
        : [...prevSelected, venueName]
    );
  };

  return (
    <div className="overflow-hidden rounded-2xl border border-gray-200 bg-white pt-4 dark:border-white/[0.05] dark:bg-white/[0.03]">
      <div className="flex flex-col gap-4 px-6 mb-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-base font-semibold text-gray-800 dark:text-white/90">
            Select Venues for this inspection Type.
          </p>
        </div>
      </div>

      <div className="max-w-full overflow-x-auto">
        <div className="min-w-[617px] 2xl:min-w-[808px]">
          <Table>
            <TableHeader className="px-6 py-3.5 border-t border-gray-100 border-y bg-gray-50 dark:border-white/[0.05] dark:bg-gray-900">
              <TableRow>
                <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                  Venues
                </TableCell>
                <TableCell className="px-6 py-3 font-medium text-gray-700 sm:px-6 text-theme-xs dark:text-gray-400 text-start">
                  <div className="flex items-center gap-3">
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                    />
                    Available in all venues
                  </div>
                </TableCell>
              </TableRow>
            </TableHeader>

            <TableBody>
              {venues.map((venue) => (
                <TableRow key={venue.name}>
                  <TableCell className="px-4 sm:px-6 py-3.5">
                    <div className="flex items-center gap-3">
                      <span className="text-gray-500 text-theme-sm dark:text-gray-400">
                        {venue.name}
                      </span>
                    </div>
                  </TableCell>
                  <TableCell className="px-4 sm:px-6 py-3.5">
                    <div className="flex items-center gap-3">
                      <Checkbox
                        checked={selectedRows.includes(venue.name)} 
                        onChange={() => handleRowSelect(venue.name)} 
                      />
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
}
